module.exports = __webpack_public_path__ + "static/eat-bitter-calligraphy-0b4fbec726b190ecccbc7240454e1131.svg";